import workbenchTypes from '@types/workbench'

export const setMenuOrder = order => ({
  type: workbenchTypes.SET_MENU_ORDER,
  payload: { order }
})

export const setSubMenuOrder = order => ({
  type: workbenchTypes.SET_SUB_MENU_ORDER,
  payload: { order }
})

export const setSubMenuActive = payload => ({
  type: workbenchTypes.SET_SUB_MENU_ACTIVE,
  payload
})

export const resetWorkbenchMenu = menus => ({
  type: workbenchTypes.RESET_MENU,
  payload: { menus }
})

export const setMenu = payload => ({
  type: workbenchTypes.SET_MENU,
  payload
})
